// 1. React and fabric. 
// 2. Store and Types. 

export default interface IOrdersLineItemsEditorProps
{
	ID             : string;
	row            : object;
	onChanged?     : (DATA_FIELD: string, DATA_VALUE: any, DISPLAY_FIELD?: string, DISPLAY_VALUE?: any) => void;
	onUpdate?      : (lineEdited: any, PARENT_FIELD: string, DATA_VALUE: any, item?: any) => void;
}

